<template>
    <div
            class="d-flex"
            @click="selectItem"
            v-bind:class="{current: isCurrent}"
            v-bind:style="styles"
            :key="item.model.id"
    >
        <div class="flex-grow-1">
            <div class="item-title">
                <span class="list-name" @click.stop="">{{ name | uppercase }}</span>
            </div>
            <div class="item-info">
                <span>{{ contactCount }} contacts, created {{ createdDiff }}</span></div>
        </div>
        <div>
            <el-tooltip content="Edit" placement="top-start">
                <span class="btn btn-link btn-link-purple btn-sm" @click.stop="edit"><i class="fas fa-edit"></i></span>
            </el-tooltip>
        </div>
    </div>
</template>

<script>
  export default {
    props: {
      isCurrent: Boolean,
      item: Object,
      select: Function,
    },

    computed: {
      /**
       * @return {string}
       */
      name() {
        return _.get(this.item, 'model.name');
      },

      /**
       * @return {number}
       */
      contactCount() {
        return _.get(this.item, 'model.contact_count', 0);
      },

      /**
       * @return {string}
       */
      createdDiff() {
        return _.get(this.item, 'created_diff');
      },

      /**
       * @return {Object}
       */
      styles() {
        const {
          'brand.item.background.color': backgroundColor
        } = _.get(this.item, 'model.brand.styles') || {};

        return _.pickBy({backgroundColor});
      },
    },

    methods: {
      /**
       * @return {undefined}
       */
      selectItem() {
        this.select(this.item);
      },

      /**
       * @emits edit
       */
      edit() {
        this.$emit('edit', this.item);
      },
    },
  }
</script>
